import useComputed from '@/hooks/use-computed'
import api from '@/services/api/pitstopConfig.js'
import { immerable } from "immer"
import { useState } from 'react'

class PitstopConfig {

	[immerable] = true

	constructor(params) {
		this.auth = params.auth
	}
}

const usePitstopConfig = (subscriptionsId) => {

	const [items, setItems] = useComputed([])

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [errorMsg, setError] = useState()

	async function fetchApiKey() {
		setLoading(true)

		const [error, data] = await api.getApiKey()

		setLoading(false)

		if (error) {
			return setError(error);
		}

		return data;
	}

	async function fetchJwtKey() {
		setLoading(true)

		const [error, data] = await api.getJwtKey()

		setLoading(false)

		if (error) {
			return setError(error);
		}

		return data;
	}


	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error);
		}

		return data
	}

	

	return {
		error:errorMsg,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		fetchApiKey,
		fetchJwtKey
	}

}

export default usePitstopConfig;
